/**
 * checkout profile constants
 */
export const SELECTED_PROFILE = 'selectedProfile';

/**
 * checkout profile modify states
 */
export const MODIFY_STATE_READ_ONLY = 0 as const;
export const MODIFY_STATE_CREATE = 1 as const;
export const MODIFY_STATE_EDIT = 2 as const;

export const EMPTY_ARRAY: any[] = [];
export const ALIAS_REGEX = /^[a-zA-ZñÑ0-9][\sa-zA-ZñÑ0-9]*$/;

// sent to backend when profile use non-card payment
export const NO_CARD_PAYMENT_VALUE = '-1';
